export const removeDoubleSlashes = (text: string) =>
    text.replace(/(\/\/+)/g, '/');

export const appendTrailingSlash = (text: string) => text + '/';
